import { render, staticRenderFns } from "./SettingExact.vue?vue&type=template&id=b40b3210&scoped=true"
import script from "./SettingExact.vue?vue&type=script&lang=js"
export * from "./SettingExact.vue?vue&type=script&lang=js"
import style0 from "./SettingExact.vue?vue&type=style&index=0&id=b40b3210&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b40b3210",
  null
  
)

export default component.exports